export default __webpack_public_path__ + "static/media/esg-90.8dc953ba.jpg";